import React, { useState, useEffect } from "react";
// import { GoogleLogin } from "react-google-login";
// import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { useDispatch } from "react-redux";
import * as actionTypes from "../redux/actionTypes";
import "./authStyles.css";
import accountant from "../assets/signIn.svg";
// import Logo from "../assets/signin.png";
// import Logo from "../assets/Image/Library/signin"
import ForgotPwd from "./ForgotPwd";
// import { Submit } from "../Components/Button";
// import { auth } from "../redux/actions/actions";
import CreatePwd from "./CreatePwd";
import { useHistory } from "react-router";
// import { emailverification } from "../WorkSpace/Components/ApiServices/apiHandler";

import signInCss from "../myfin_v2/css/signIn.module.css"
import commoncss from "../myfin_v2/css/common.module.css"
// import companycss from "../myfin_v2/css/company.module.css"
import buttoncss from "../myfin_v2/css/button.module.css"
import { ReactComponent as MyFinLogo } from "../myfin_v2/assets/icons/myfinLogo.svg"
import { ReactComponent as HideIcon } from "../myfin_v2/assets/icons/hide.svg"
import { ReactComponent as ShowIcon } from "../myfin_v2/assets/icons/show.svg"
import InputGroup from "../myfin_v2/elements/InputGroup";


const initialErrors = { email: false, password: false };
const SignIn = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [error, seterror] = useState(initialErrors);
  const [valid, setValid] = useState(false);
  // const [forgotPswd, setForgotPswd] = useState(false);
  const [Value, setValue] = useState({ email: "", password: "" });
  const [Show, setShow] = useState(false);
  const [modalopen, setModalOpen] = useState(false);
  const [ShowPwd, setShowPwd] = useState(false);
  const [userId, setUserId] = useState('')

  function modalshow() {
    if (error.email && Value.email.length > 0) {
      swal({
        // title: "chcek your email",
        text: "Clicking on Okay will send an OTP to your e-mail",
        // icon: "warning",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          const fd = new FormData();
          fd.append("email", Value.email);
          axios
            .post("api/v1/auth/check-email", fd)
            .then((res) => {
              setShow(!Show);
              swal(`OTP sent to ${Value.email}`, {
                icon: "success",
              });
              // console.log(res,'api call')
            })
            .catch((err) => {
              // console.log(err.response)
              // swal(err.response.data.error)
              swal("", err.response.data.error, "error");
            });
        } else {
          swal("OTP not sent");
        }
      });

      return;
    }
    swal(`please enter a valid email`, {
      icon: "error",
    });
    // setForgotPswd(!forgotPswd)
    // setForgotPswd(false)
    console.log("modal open");
  }

  // function passwordmodalshow() {

  //   setModalOpen(!modalopen);
  //   console.log(modalopen, 'modalopen----');


  // }

  function validation() {
    let temp = { ...error };
    const pattern = /[a-zA-Z0-9]+\.?([a-zA-Z0-9]+)?@[a-z]{3,10}\.[a-z]{2,5}/g;
    temp.email =
      pattern.test(Value.email) | (Value.email.length === 0) ? true : false;
    temp.password = Value.password.length > 0 ? true : false;
    if (temp.email & temp.password) {
      setValid(true);
    } else {
      setValid(false);
    }
    seterror(temp);
    console.log(temp, "validation");
  }

  //   function validation() {
  //   let temp = { ...error };
  //   const pattern = /^[a-zA-Z0-9]+\.?([a-zA-Z0-9]+)?@[a-z]{3,10}\.[a-z]{2,5}$/;

  //   temp.email = pattern.test(Value.email) || Value.email.length === 0;
  //   temp.password = Value.password.length > 0;

  //   setValid(temp.email && temp.password);
  //   seterror(temp);

  //   console.log(temp, "validation");
  // }

  function handleChange(e) {
    setValue({ ...Value, [e.target.name]: e.target.value });
    console.log(Value, error, "values and errors");
  }

  useEffect(() => {
    validation();
    console.log(valid);
  }, [Value]);

  console.log(Show, "modal true");

  function handleSignUp() {
    if ((Value.email.length === 0) | (Value.password.length === 0)) {
      swal("", "fill all the required fields!", "warning");
    } else {
      console.log(Value);

      let fd = {
        email: Value.email,
        password: Value.password,
      };

      axios
        .post("/api/v1/auth/login", fd)
        .then((res) => {
          console.log("res",res.data);

          if (res.data.expired) {
            swal({
              title: "Password Expired",
              text: "Your password has expired. Please reset it.",
              icon: "warning",
              buttons: {
                cancel: "Close",
                reset: {
                  text: "Reset Password",
                  value: "reset",
                },
              },
            }).then((value) => {
              if (value === "reset") {
                history.push(`/createpassword/${res.data.userId}`);
              }
            });
            return;
          }
          
          if (res.data.user.temp_password) {
            setUserId(res.data.user._id)
            return history.push(`/createpassword/${res.data.user._id}`)
          }
          // if (res.data.user.confirmation_code) {
          //   swal("Please verify your email with OTP")
          //   localStorage.setItem('user', JSON.stringify(res.data.user));
          //   return history.push(`/emailverify/${res.data.user._id}`);
          // }
          localStorage.setItem("auth_token", res.data.token);
          localStorage.setItem("user_id", res.data.user._id);
          localStorage.setItem('user', JSON.stringify(res.data.user));
          localStorage.setItem('permission', JSON.stringify(res.data.permission));
          props.history.push("/dashboard");
          window.location.reload(); //reload added for socket login issue
        })
        .catch((err) => {
          console.log(err.response, "sign in error");
          swal("Error", err.response?.data?.error, "error")
        });
    }
  }

  return (
    <div className="conatiner">
      <ForgotPwd Show={Show} setShow={setShow} email={Value.email}/>
      <CreatePwd modalopen={modalopen} setModalOpen={setModalOpen} userId={userId} />

      <div className={signInCss.imgContainer}>
        <img src={accountant} alt="accountant working" style={{
          "height": "93.7vh", "place-self": "center"
        }}></img>
      </div>
      <div className={signInCss.formContainer}>
        <div
          className={commoncss.dFlexJustifysb}

        >
          <div className={commoncss.dFlex}>
            <div className={commoncss.dFlexClm}>
              <span className={signInCss.heading1}>
                Hello there!
              </span>
              <span className={signInCss.label1}>
                Sign in or create an account to proceed
              </span>
            </div>
          </div>
          <div>
            <MyFinLogo />
          </div>
        </div>
        <div className={signInCss.container2}>
          <div className="button-group">
            <button
              className={`${buttoncss.primary}`}
              style={{ "border-radius": "8.18px 0px 0px 8.18px", "padding": "5px 15px", "width": "130px" }}
              onClick={() => {
                // setRequestType("PULL");
              }}
            >
              Sign in
            </button>
            <Link to="/signup">
              <button
                className={`${buttoncss.secondary
                  }`}
                style={{
                  "border-radius": "0 8.18px 8.18px 0", "padding": "5px 15px", "width": "130px"
                }}
                onClick={() => {

                }}
              >
                Sign up
              </button>
            </Link>
          </div>
          <div className={`${signInCss.container3} mt-2`}>
            <form
              onSubmit={(e) => {
                console.log("submit");
                e.preventDefault();
              }}
            >
              <InputGroup
                class_="mt-4"
                label="Email"
                inputs={[
                  <>
                    <input
                      id={error.email ? "fname" : "error"}
                      value={Value.email}
                      type="text"
                      onChange={handleChange}
                      placeholder="Enter email id"
                      name="email"
                    />
                    {error.email ? null : (
                      <p style={{ color: "red", margin: "5px 5px 0px 5px", fontSize: "14px" }}>
                        please enter a valid email id
                      </p>
                    )}

                  </>,
                ]}
              />

              <InputGroup
                class_="mt-2"
                label="Password"
                inputs={[
                  <>
                    <input
                      id="fname"
                      onChange={handleChange}
                      value={Value.password}
                      name="password"
                      placeholder="Enter password"
                      type={!ShowPwd ? "password" : "text"}
                    />
                    <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto" }} onClick={() => setShowPwd(!ShowPwd)}>
                      {ShowPwd ? <ShowIcon height={18} /> : <HideIcon height={18} /> }
                    </span>
                  </>,
                ]}
              />
              <div className="w-100 mt-4" onClick={handleSignUp}>
                {valid ? (
                  <button type="submit" className={buttoncss.primary} value="Sign in" style={{ "padding": "7px", "width": "100%", "border-radius": "12px" }}>Log in</button>

                ) : (
                  <button type="submit" className={buttoncss.primary} value="Sign in" style={{ "padding": "7px", "width": "100%", "border-radius": "12px" }} disabled>Log in</button>
                )}
              </div>
              <div className={`${signInCss.label2} mt-3`} onClick={modalshow} style={{ cursor: "pointer" }}>
                I forgot my password
              </div>
              <div className={signInCss.label3}>
                <span>Don't you have any account?</span> <Link to="/signup" className={signInCss.label2}>Sign up</Link>
              </div>
            </form>
          </div>
          <div
            className={`w-100 ${signInCss.tnc}`}
          >
            <span>
              <span className={signInCss.label1}>By joining, you agree to the</span><span className={signInCss.label2}>Terms and Privacy Policy</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
